"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var React = _interopRequireWildcard(require("react"));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
function SvgComponent(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    x1: "50%",
    y1: "100%",
    x2: "50%",
    y2: "0%",
    id: "prefix__a"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F7F0ED",
    offset: "100%"
  }))), /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M-373-6785h1920V3902H-373z"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#prefix__a)",
    d: "M0 0h1064v1979H0z",
    transform: "translate(-373 -781)"
  }), /*#__PURE__*/React.createElement("g", {
    strokeWidth: 1.5,
    transform: "translate(.465)",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.652.748l-3.75 2.25 2.25 3.75M23.25 8.187a6.749 6.749 0 00-6.884-4.417M4.348 23.248l3.75-2.25-2.25-3.75M.75 15.808a6.749 6.749 0 006.884 4.417"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.75,
    y: 0.748,
    width: 12,
    height: 12,
    rx: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.75 11.248h6a1.5 1.5 0 011.5 1.5v9a1.5 1.5 0 01-1.5 1.5h-9a1.5 1.5 0 01-1.5-1.5v-6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.75 20.248v-4.5a1.5 1.5 0 013 0v4.5M15.75 18.748h3M6.75 3.748v1.5M3.75 5.248h6M8.25 5.248s-1.5 4.5-4.5 4.5M6.749 8.014a3.933 3.933 0 003 1.734"
  })))));
}
var _default = exports["default"] = SvgComponent;